<button type="button" class="eva-dashed-add-button" (click)="buttonClick.emit()">
  @if (isNgIconName(icon)) {
    <ng-icon [name]="icon" />
  } @else {
    <i class="pi" [ngClass]="icon"></i>
  }
  @if (label) {
    <span>{{ label }}</span>
  }
</button>
